import React from 'react'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import { Stack, Typography } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import { useNavigate } from 'react-router-dom'

interface Props {
    rightText?: string
    onClickRightText?: Function
    onClickBack: Function
}

const NavigationHeader = ({
    rightText,
    onClickRightText,
    onClickBack,
}: Props) => {
    return (
        <Stack
            direction='row'
            justifyContent='space-between'
            style={{ marginTop: '0.5rem' }}>
            <Stack direction='row' onClick={() => onClickBack()}>
                <Typography
                    sx={{
                        cursor: 'pointer',
                        color: 'primary.main',
                        display: 'flex',
                        fontSize: '1.125rem',
                        alignItems: 'center',
                    }}>
                    <ArrowBackIosIcon
                        sx={{ marginRight: '0.25rem' }}
                        fontSize='small'
                    />
                    <FormattedMessage id='button-back' />
                </Typography>
            </Stack>
            {rightText && onClickRightText && (
                <Typography
                    onClick={() => onClickRightText()}
                    sx={{
                        cursor: 'pointer',
                        color: 'primary.main',
                        display: 'flex',
                        fontSize: '1.125rem',
                    }}>
                    <FormattedMessage id={rightText} />
                </Typography>
            )}
        </Stack>
    )
}
export default NavigationHeader
